// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c7a586c4","337":"b0c5bd70","455":"d265349c"}[chunkId] + ".chunk.js";
};